<template>
  <div class="v-container">
    <div class="v-page-header">角色管理</div>
    <div class="v-header">
      <el-button type="primary" size="small" @click="add">
        <i class="el-icon-plus"></i>
        添加角色
      </el-button>
      <div>
        <el-select v-loading="wxLoading" v-model="shop_id" placeholder="筛选小程序" style="width: 200px; margin-right: 5px" size="mini">
          <el-option v-for="item in wxList" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
        <el-input v-model="keyword" class="v-form-item" size="mini" placeholder="请输入角色名称" style="width: 200px"></el-input>
        <el-button class="v-ml-5" type="primary" size="mini" @click="getList(1)">搜索</el-button>
        <el-button size="mini" @click="reset">重置</el-button>
      </div>
    </div>
    <div class="v-content" v-loading="loading">
      <el-table :data="lists" border size="small" style="width: 100%">
        <el-table-column prop="id" label="ID" width="50" />
        <el-table-column prop="name" label="角色名称" />
        <el-table-column prop="shop_name" label="小程序" width="200" />
        <el-table-column prop="" label="角色类型" width="80">
          <template slot-scope="scope">{{ scope.row.type == 1 ? '运营方' : '观察者' }}</template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" width="200" />
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-tooltip effect="dark" content="权限设置" placement="top">
              <el-button @click="setPower(scope.row)" type="default" size="min">
                <i style="font-size: 12px" class="iconfont icon-permission"></i>
              </el-button>
            </el-tooltip>
            <el-button @click="edit(scope.row)" type="default" size="min" icon="el-icon-edit" />
            <el-button @click="del(scope.row)" :loading="scope.row.loading" type="default" size="min" icon="el-icon-delete" />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="v-footer">
      <el-pagination
        layout="total,sizes,prev, pager, next"
        @size-change="
          (page_size) => {
            getList(page, page_size);
          }
        "
        @current-change="
          (page) => {
            getList(page);
          }
        "
        :current-page.sync="page"
        :total="total"
      ></el-pagination>
    </div>
    <role-add-edit
      v-if="isShowAddEdit"
      :isShow.sync="isShowAddEdit"
      @success="
        (page) => {
          getList(page);
        }
      "
      :row="row"
    />
    <role-permission
      v-if="isShowSetPower"
      :isShowPower.sync="isShowSetPower"
      @success="
        (page) => {
          getList(page);
        }
      "
      :row="row"
    />
  </div>
</template>

<script>
import RoleAddEdit from './components/role-add-edit';
import RolePermission from './components/role-permission';

export default {
  components: { RoleAddEdit, RolePermission },
  data() {
    return {
      page: 1,
      page_size: 10,
      total: 0,
      lists: [], // table数据
      isShowAddEdit: false, // 显示新增修改弹窗
      isShowSetPower: false, // 显示设置权限
      loading: false, // 页面loading
      addEditType: 1, // 1添加 2修改 3添加子类
      row: null, // 操作时row
      keyword: '',
      shop_id: '',
      wxLoading: false,
      wxList: [],
    };
  },
  created() {
    this.getList();
    this.getWxList();
  },
  methods: {
    // 获取列表
    async getList(page, page_size) {
      this.loading = true;
      this.page = page ? page : this.page;
      this.page_size = page_size ? page_size : this.page_size;
      try {
        let res = await this.api.userAdmin.getRoleList({
          page: this.page,
          page_size: this.page_size,
          keyword: this.keyword,
          shop_id: this.shop_id,
        });
        this.lists = res.data.data;
        this.total = res.data.total;
      } catch (ex) {
        console.error(ex);
      }
      this.loading = false;
    },

    async getWxList() {
      this.wxLoading = true;
      try {
        let res = await this.api.shop.lists();
        this.wxList = res.data;
      } catch (e) {
        console.error(e);
      }
      this.wxLoading = false;
    },

    reset() {
      this.keyword = '';
      this.shop_id = '';
      this.getList(1);
    },

    // 添加
    add() {
      this.row = null;
      this.isShowAddEdit = true;
    },

    // 修改
    edit(row) {
      this.row = row;
      this.isShowAddEdit = true;
    },

    // 删除
    del(row) {
      this.$confirm('确认删除么?', '友情提示', {
        type: 'warning',
      })
        .then(async () => {
          this.doDel(row);
        })
        .catch(() => {});
    },

    //删除提交
    async doDel(row) {
      row.loading = true;
      try {
        let res = await this.api.userAdmin.deleteRole({ id: row.id });
        this.$message.success(res.message);
      } catch (ex) {
        console.error(ex);
      }
      row.loading = false;
      this.getList();
    },

    // 设置权限
    setPower(row) {
      this.row = row;
      this.isShowSetPower = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-header {
  display: flex;
  align-items: center;
  padding: 0 0 15px 0;
  justify-content: space-between;
}
</style>
